module.exports = __webpack_public_path__ + "img/hoverZoomimg.90ea0ca7.svg";